import { type StructuredContentDocument } from '@repo/supergraph/structuredContent/types';
import { NerdyTip as NerdyTipUI } from '@repo/ui/NerdyTip';
import { StructuredContentRenderer } from '../..';

export type NerdyTipProps = StructuredContentDocument<{
  children: Array<StructuredContentDocument>;
}>;

export function NerdyTip({ props }: NerdyTipProps) {
  if (!props) {
    return null;
  }
  return (
    <NerdyTipUI>
      {props.children?.map((child, index) => {
        return <StructuredContentRenderer doc={child} key={index} />;
      })}
    </NerdyTipUI>
  );
}
